import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { getContactInfo, submitContact } from "@/lib/api";
import { validateContact } from "@/lib/formValidation";

const EMPTY_FORM = { name: "", email: "", phoneDial: "+91", phone: "", message: "" };

export function useContactInfo() {
  const [email, setEmail] = useState(null);
  useEffect(() => {
    let active = true;
    getContactInfo().then((data) => { if (active) setEmail(data.email); })
      .catch(() => { if (active) setEmail(null); });
    return () => { active = false; };
  }, []);
  return email;
}

export function useContactForm() {
  const [form, setForm] = useState(() => ({ ...EMPTY_FORM }));
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const submit = async (event) => {
    event.preventDefault();
    if (status === "sending") return;
    const nextErrors = validateContact(form);
    setErrors(nextErrors);
    if (Object.keys(nextErrors).length) return;
    setStatus("sending");
    try {
      await submitContact({ name: form.name, email: form.email,
        phone: `${form.phoneDial}${form.phone}`, message: form.message });
      if (mounted.current) setStatus("done");
    } catch {
      if (mounted.current) {
        setStatus("idle");
        toast.error("Something went wrong. Please try again.");
      }
    }
  };
  const updateField = (field, value) => setForm((current) => ({ ...current, [field]: value }));
  return { form, errors, status, submit, updateField };
}